import React from 'react';
import Edit from '../icons/Edit';
import Visibility from '../icons/Visibility';

const MAX_VISIBLE_AVATARS = 5;

/**
 * PagePresenceBar shows avatars of users currently viewing/editing the page.
 * Uses Socket.IO page presence data. Shows an edit icon for editors/owners
 * and an eye icon for viewers.
 *
 * @param {{ users: Array<{ userId, name, picture, role, color }> }} props
 */
const PagePresenceBar = ({ users = [] }) => {
  if (users.length === 0) return null;

  const visibleUsers = users.slice(0, MAX_VISIBLE_AVATARS);
  const overflow = users.length - MAX_VISIBLE_AVATARS;

  const isEditor = (role) => role === 'editor' || role === 'owner';

  return (
    <div className="page-presence-bar">
      {visibleUsers.map((user) => (
        <div
          key={user.userId}
          className={`presence-avatar ${isEditor(user.role) ? 'editing' : 'viewing'}`}
          style={{ borderColor: user.color }}
          title={`${user.name} (${isEditor(user.role) ? 'editing' : 'viewing'})`}
        >
          <div
            className="presence-avatar-inner"
            style={{ backgroundColor: user.color }}
          >
            {user.picture ? (
              <img src={user.picture} alt={user.name} />
            ) : (
              user.name?.charAt(0) || '?'
            )}
          </div>
          <span className="presence-role-badge" style={{ backgroundColor: user.color }}>
            {isEditor(user.role) ? (
              <Edit size={11} color="#fff" />
            ) : (
              <Visibility size={11} color="#fff" />
            )}
          </span>
        </div>
      ))}
      {overflow > 0 && (
        <div className="presence-overflow" title={`${overflow} more`}>
          +{overflow}
        </div>
      )}
    </div>
  );
};

export default PagePresenceBar;
